var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 272 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15374 5.69474L6.20219 6.503C6.8624 6.63481 7.37848 7.15089 7.5103 7.81111L8.31856 11.8596L12.198 1.81529L2.15374 5.69474ZM1.02892 5.47017C1.02905 5.4702 1.02917 5.47022 1.02929 5.47025ZM0.723469 5.17516L12.54 0.611197C13.0797 0.402746 13.6105 0.933586 13.4021 1.47329L8.83813 13.2898C8.59769 13.9124 7.69313 13.8346 7.56247 13.1802L6.52965 8.00689C6.47692 7.7428 6.27049 7.53637 6.00641 7.48365L0.833141 6.45082C0.178713 6.32017 0.100946 5.4156 0.723469 5.17516Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.cb6d9f98450046c8fb8a5984d2c03ee6.svg";
export { ForwardRef as ReactComponent };